import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sale-box-bar"
}
const _hoisted_2 = { class: "sale-box-bar__product-name-wrapper" }
const _hoisted_3 = { class: "sale-box-bar__product-name" }
const _hoisted_4 = {
  key: 0,
  class: "sale-box__zero-price-wrapper"
}
const _hoisted_5 = { class: "sale-box__buttons" }
const _hoisted_6 = { class: "product-box__status product-box__status--unavailable" }
const _hoisted_7 = {
  key: 1,
  class: "sale-box-bar__conversion-wrapper"
}
const _hoisted_8 = {
  key: 0,
  class: "sale-box-bar__savedPercentage sale-box__price--savedPercentage"
}
const _hoisted_9 = {
  key: 2,
  class: "sale-box__buttons"
}
const _hoisted_10 = { class: "product-box__status product-box__status--unavailable" }
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_availability_info = _resolveComponent("availability-info")!
  const _component_product_navigation_price_info = _resolveComponent("product-navigation-price-info")!
  const _component_counter_input = _resolveComponent("counter-input")!

  return (!_ctx.product.purchaseOnRequestArticle)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.product.name), 1 /* TEXT */),
          _cache[2] || (_cache[2] = _createTextVNode()),
          (!_ctx.product.inBasket && !_ctx.product.zeroPriceItem && !_ctx.product.recurringOrderFollowUpPacket)
            ? (_openBlock(), _createBlock(_component_availability_info, {
                key: 0,
                class: "sale-box-bar__availability",
                availability: _ctx.product.availability
              }, null, 8 /* PROPS */, ["availability"]))
            : _createCommentVNode("v-if", true)
        ]),
        _cache[7] || (_cache[7] = _createTextVNode()),
        (!_ctx.isPriceInfoVisible())
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('availability.no-price')), 1 /* TEXT */)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.product.price.savedPercentage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, "\n        -" + _toDisplayString(_ctx.product.price.savedPercentage) + "%\n      ", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _cache[4] || (_cache[4] = _createTextVNode()),
              _createVNode(_component_product_navigation_price_info, {
                class: "sale-box-bar__price",
                value: _ctx.product.price,
                "show-tax": true,
                "shipping-info-url": _ctx.product.shippingInfoUrl,
                "show-shipping-included": _ctx.product.deliveryCostIncluded,
                "with-savings-max": _ctx.productDetails.pageType === 'AQ_LANDING_PAGE'
              }, null, 8 /* PROPS */, ["value", "shipping-info-url", "show-shipping-included", "with-savings-max"]),
              _cache[5] || (_cache[5] = _createTextVNode()),
              (_ctx.onePageCheckout)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "sale-box__button-opc | button button--secondary-arrow",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToCheckout()))
                  }, _toDisplayString(_ctx.$t('onepagecheckout.go_to_checkout')), 1 /* TEXT */))
                : (!_ctx.productDetails.product.zeroPriceItem && _ctx.productDetails.product.recurringOrderFollowUpPacket)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('product.button.recurringOrderFollowUpPacket')), 1 /* TEXT */)
                    ]))
                  : (_ctx.product.availability.available && !_ctx.product.inBasket && !_ctx.addToBasketHtmlReplacement)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createVNode(_component_counter_input, {
                          class: "sale-box-bar__counter",
                          counter: _ctx.product.counter,
                          onUpdate: _ctx.counterChangeHandler,
                          ref: "quantity"
                        }, null, 8 /* PROPS */, ["counter", "onUpdate"]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("button", {
                          class: _normalizeClass(["sale-box-bar__add-to-basket | button button--add-to-basket", {
            'button--loading': _ctx.state === 'loadingBasket'
          }]),
                          type: "button",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addToBasket && _ctx.addToBasket(...args)))
                        }, null, 2 /* CLASS */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
              _cache[6] || (_cache[6] = _createTextVNode()),
              (_ctx.product.inBasket)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 4,
                    class: "sale-box__status-basket",
                    href: _ctx.basketUrl
                  }, _toDisplayString(_ctx.$t('ads.ads_top_info.article_in_basket')), 9 /* TEXT, PROPS */, _hoisted_11))
                : _createCommentVNode("v-if", true)
            ]))
      ]))
    : _createCommentVNode("v-if", true)
}